import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { MatExpansionModule } from '@angular/material/expansion';
import { CoAppCommonQuestionsComponent } from './co-app-common-questions/co-app-common-questions.component';
import { CoAppRoutingModule } from './co-app-routing.module';
import { CoAppInviteSentComponent } from './co-app-invite-sent/co-app-invite-sent.component';
import { CoAppInviteComponent } from './co-app-invite/co-app-invite.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CoAppLandingComponent } from './co-app-landing/co-app-landing.component';
import { CoAppConfirmSheetComponent } from './app-co-app-confirm-sheet/co-app-confirm-sheet.component';

@NgModule({
	declarations: [
		CoAppInviteComponent,
		CoAppCommonQuestionsComponent,
		CoAppInviteSentComponent,
		CoAppConfirmSheetComponent,
		CoAppLandingComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		MatExpansionModule,
		TranslocoModule,
		NgxMaskModule.forChild(),
		CoAppRoutingModule,
		MatBottomSheetModule
	],
	exports: [CoAppCommonQuestionsComponent]
})
export class CoAppModule {}
